<template>
	<main>
		<h1>API tokens</h1>

		<p>
			<RouterLink to="/api_token/new">New token</RouterLink>
		</p>

		<ApiTokenListItem
			v-for="token in tokens"
			:key="token.id"
			:token="token"
			@requestNameChange="editName(token, $event)"
			@requestDelete="deleteToken(token)"
		/>
	</main>
</template>

<script>
import { getErrors } from '@/core/http'
import apiTokensHttp from '../apiTokensHttp'
import ApiTokenListItem from '../components/ApiTokenListItem'

export default {
	name: 'ApiToken',
	components: {
		ApiTokenListItem,
	},
	data() {
		return {
			tokens: [],
		};
	},
	created() {
		this.fetchApiTokens()
			.then(tokens => {
				this.tokens = tokens;
			})
			.catch(response => {
				const errors = getErrors(response);

				errors.forEach((text) => {
					this.$flashMessage.show({
						type: 'error',
						text,
					});
				});
			})
		;
	},
	methods: {
		async fetchApiTokens() {
			return await apiTokensHttp.getAll();
		},
		handleRequestError(response) {
			const errors = getErrors(response);

			errors.forEach((text) => {
				this.$flashMessage.show({
					type: 'error',
					text,
				});
			});
		},
		async editName(token, newName) {
			try {
				await apiTokensHttp.put(token.id, {
					name: newName,
				});

				token.name = newName;

			} catch (response) {
				this.handleRequestError(response);
			}
		},
		async deleteToken(token) {
			try {
				await apiTokensHttp.delete(token.id);

				const tokenIndex = this.tokens.findIndex(tokenTest => tokenTest.id === token.id);

				if (tokenIndex >= 0) {
					this.tokens.splice(tokenIndex, 1);
				}

			} catch (response) {
				this.handleRequestError(response);
			}
		},
	},
};
</script>
